import Div from '@/shared/Div';
import Paragraph from '@/shared/Paragraph';
import ProgressBar from '@/shared/crisp/ProgressBar';
import React, { Fragment, memo } from 'react';

type PaginationProps = {
  resultsCount: number;
  total: number;
};

const Pagination = ({ resultsCount, total }: PaginationProps) => {
  if (resultsCount <= 0) return null;
  return (
    <Div className="flex flex-col gap-s5 justify-center w-48 mx-auto text-center text-body-lg md:text-body-base text-cti-secondary mb-s5">
      <Paragraph>
        Showing {resultsCount} of {total} results
      </Paragraph>
      <ProgressBar progressBarPercentage={`${(resultsCount / total) * 100}%`} />
    </Div>
  );
};

export default memo(Pagination);
